import client from './client';
import { unwrapData } from './response';

export const listSpecies = async () => {
  const response = await client.get('/pets/species/list');
  return unwrapData(response);
};

export const listPets = async (params = {}) => {
  const response = await client.get('/pets', { params });
  return unwrapData(response);
};

export const getPet = async (id) => {
  const response = await client.get(`/pets/${id}`);
  return unwrapData(response, null);
};

export const createPet = async (payload) => {
  const response = await client.post('/pets', payload);
  return unwrapData(response, null);
};

export const updatePet = async (id, payload) => {
  const response = await client.patch(`/pets/${id}`, payload);
  return unwrapData(response, null);
};

export const deletePet = async (id) => {
  const response = await client.delete(`/pets/${id}`);
  return unwrapData(response, null);
};

export const listPetMedicalRecords = async (petId) => {
  const response = await client.get(`/pets/${petId}/medical-records`);
  return unwrapData(response);
};

export const createPetMedicalRecord = async (petId, payload) => {
  const response = await client.post(`/pets/${petId}/medical-records`, payload);
  return unwrapData(response, null);
};

export const uploadMedicalRecordAttachments = async (recordId, files = []) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  const response = await client.post(`/medical-records/${recordId}/attachments`, formData);
  return unwrapData(response);
};

export const listPetUpcomingEvents = async (petId) => {
  const response = await client.get(`/pets/${petId}/upcoming-events`);
  return unwrapData(response);
};

export const listPetEvents = async (params = {}) => {
  const response = await client.get('/pet-events', { params });
  return unwrapData(response);
};

export const createPetEvent = async (payload) => {
  const response = await client.post('/pet-events', payload);
  return unwrapData(response, null);
};

export const updatePetEvent = async (id, payload) => {
  const response = await client.put(`/pet-events/${id}`, payload);
  return unwrapData(response, null);
};

export const deletePetEvent = async (id) => {
  const response = await client.delete(`/pet-events/${id}`);
  return unwrapData(response, null);
};
